export const config = {
  title: "Primetime Lobos Detailing",
  meta: {
    description:
      "Primetime Lobos Detailing offers professional auto detailing services in Broken Arrow, OK. Specializing in interior and exterior detailing, ceramic coating, paint correction, and more.",
    keywords: [
      "Auto Detailing Broken Arrow",
      "Car Detailing Oklahoma",
      "Ceramic Coating",
      "Paint Correction",
      "Primetime Lobos Detailing",
    ],
    author: "Primetime Lobos Detailing",
    canonicalUrl: "https://www.ptldetailing.com/",
  },
  sections: {
    header: {
      businessName: "Primetime Lobos Detailing",
    },
    sectionB: {
      heroTitle: "Primetime Lobos Detailing",
      heroSubtitle: "Professional Auto Detailing in Broken Arrow, OK",
      learnAboutText: "Explore Our Services",
      phoneNumber: "9182859629",
      phoneLabel: "(918) 285-9629",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1272577182/photo/car-detailing.jpg?s=612x612&w=0&k=20&c=AmH7v05Y2Yt5rf1yTiCRYrglU9-cbIwiQgAgrq3ljnY=",
      cardData: [
        {
          title: "Interior Detailing",
          description:
            "Comprehensive interior cleaning to restore your vehicle's cabin to like-new condition.",
        },
        {
          title: "Exterior Detailing",
          description:
            "Thorough exterior wash and polish to enhance your vehicle's appearance.",
        },
        {
          title: "Ceramic Coating",
          description:
            "Advanced ceramic coating application for long-lasting paint protection.",
        },
      ],
      description:
        "At Primetime Lobos Detailing, we provide top-tier auto detailing services in Broken Arrow, OK. Our team is dedicated to delivering exceptional results, ensuring your vehicle looks and feels brand new.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Discover our range of professional auto detailing services tailored to meet your vehicle's needs.",
      cards: [
        {
          title: "Interior Detailing",
          description:
            "Deep cleaning of seats, carpets, and all interior surfaces for a fresh cabin feel.",
          imageSrc: "https://media.istockphoto.com/id/1288964234/photo/car-detailing-service-deep-interior-cleaning.jpg?s=612x612&w=0&k=20&c=O1jFEKtCipreEAIOhEkIwYxkq0OBd8rMYe8bOFPngtc=",
          imageAlt: "Interior Detailing",
        },
        {
          title: "Exterior Detailing",
          description:
            "Comprehensive exterior cleaning, including wash, wax, and polish.",
          imageSrc: "https://media.istockphoto.com/id/1194687583/photo/worker-examining-vehicle-body-for-scratches.jpg?s=612x612&w=0&k=20&c=tYB4Bgir9Y4eO2x6XazRXnrSnBHZB7t0BOU0j2tYPZ8=",
          imageAlt: "Exterior Detailing",
        },
        {
          title: "Ceramic Coating",
          description:
            "Application of ceramic coating to protect your vehicle's paint and enhance shine.",
          imageSrc: "https://media.istockphoto.com/id/1273682054/photo/car-service-worker-applying-nano-coating-on-a-car-detail.jpg?s=612x612&w=0&k=20&c=w2YoGPnv24lcITfiH7jnTYLAj9xCXUrlbHn33lxcd2U=",
          imageAlt: "Ceramic Coating",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Paint Correction",
        "Debadging",
        "Window Tinting",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://lirp.cdn-website.com/48b9aa8b/dms3rep/multi/opt/auto+detailing+logo-1920w.png",
        alt: "Primetime Lobos Detailing Team",
      },
      aboutText: [
        "Primetime Lobos Detailing is a premier auto detailing service based in Broken Arrow, OK. Our mission is to provide exceptional detailing services that exceed our clients' expectations.",
        "With a passion for automotive care, our experienced team uses high-quality products and techniques to ensure your vehicle receives the best treatment possible.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Primetime Lobos Detailing Logo",
      businessName: "Primetime Lobos Detailing",
      contact: {
        phone: "9182859629",
        phoneLabel: "(918) 285-9629",
        email: "primetimelobosllc@gmail.com",
        website: "https://www.ptldetailing.com/",
        address: "1042 North 6th Street, Broken Arrow, OK 74012",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/PrimetimeLobosDetailing",
        instagram: "https://www.instagram.com/primetime_pros/",
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "1042 North 6th Street, Broken Arrow, OK 74012",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3349.1234567890123!2d-95.79012345678901!3d36.06234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87b6c12345678901%3A0xabcdef1234567890!2s1042%20N%206th%20St%2C%20Broken%20Arrow%2C%20OK%2074012!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
